import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/auth';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  const userType = localStorage.getItem('userType');

  // Must be authenticated AND be admin userType
  if (!isAuthenticated || userType !== 'admin') {
    // Redirect to login if not authenticated as admin
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
